var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_5270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4769 11.9929L9.14712 2.66572C9.03091 2.46066 8.86238 2.29009 8.65873 2.17142C8.45508 2.05276 8.22359 1.99023 7.98789 1.99023C7.75219 1.99023 7.5207 2.05276 7.31705 2.17142C7.1134 2.29009 6.94487 2.46066 6.82866 2.66572L1.49886 11.9929C1.38139 12.1963 1.3198 12.4272 1.32032 12.6621C1.32084 12.897 1.38345 13.1276 1.50182 13.3305C1.62019 13.5334 1.7901 13.7015 1.99433 13.8175C2.19856 13.9336 2.42985 13.9937 2.66475 13.9915H13.3244C13.5581 13.9913 13.7877 13.9296 13.9901 13.8125C14.1925 13.6955 14.3605 13.5272 14.4773 13.3247C14.594 13.1222 14.6555 12.8925 14.6554 12.6588C14.6554 12.425 14.5938 12.1953 14.4769 11.9929Z",
    stroke: "#D08700",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99414 5.99609V8.66099",
    stroke: "#D08700",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99414 11.3262H8.0008",
    stroke: "#D08700",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_5270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e891ba82289eac6c78fdb7d4902a80f8.svg";
export { ForwardRef as ReactComponent };